module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.vvType) ? _c('f7-page', {
    class: _vm.listKey.toLowerCase(),
    attrs: {
      "pull-to-refresh": "",
      "infinite-scroll": _vm.vLayout !== 'table'
    },
    on: {
      "ptr:refresh": _vm.onRefresh,
      "infinite": _vm.onInfiniteScroll
    }
  }, [_c('f7-navbar', {
    style: (_vm.searching ? 'box-shadow: none' : ''),
    attrs: {
      "title": _vm.pageTitle + (_vm.showTotal === true && _vm.total ? ' ( ' + _vm.total + ' )' : ''),
      "back-link": _vm.vvType === 'vlistfield' ? '' : ' ',
      "sliding": ""
    }
  }, [(_vm.sorting) ? _vm._t("default", [(_vm.showLayout) ? _vm._t("default", [_c('f7-nav-right', [_c('f7-link', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.changeLayout
    }
  }, [_c('f7-icon', {
    attrs: {
      "icon": 'icon-layout-' + (_vm.layout === 'table' ? 'card' : 'table')
    }
  })], 1)], 1), _vm._v(" "), _c('f7-nav-left', [_c('f7-link', {
    class: 'popover-sort-' + _vm.listKey.toLowerCase() + '-place' + (_vm.vvType === 'vlistfield' ? '-vlistfield' : ''),
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showSortPopup
    }
  }, [_c('f7-icon', {
    attrs: {
      "icon": "icon-sort"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showPanel) ? _c('f7-nav-left', [_c('f7-link', {
    attrs: {
      "icon": "icon-bars",
      "open-panel": "left"
    }
  })], 1) : _vm._e()]) : _vm._t("default", [_c('f7-nav-right', [_c('f7-link', {
    class: 'popover-sort-' + _vm.listKey.toLowerCase() + '-place' + (_vm.vvType === 'vlistfield' ? '-vlistfield' : ''),
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showSortPopup
    }
  }, [_c('f7-icon', {
    attrs: {
      "icon": "icon-sort"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showPanel) ? _c('f7-nav-left', [_c('f7-link', {
    attrs: {
      "icon": "icon-bars",
      "open-panel": "left"
    }
  })], 1) : _vm._e()])]) : _vm._t("default", [(_vm.showPanel) ? _c('f7-nav-right', [_c('f7-link', {
    attrs: {
      "icon": "icon-bars",
      "open-panel": "left"
    }
  })], 1) : _vm._e()])], 2), _vm._v(" "), (_vm.searching) ? _c('f7-searchbar', {
    attrs: {
      "cancel-link": "Cancel",
      "placeholder": _vm.searchTitle,
      "clear-button": true
    },
    on: {
      "click:clear": _vm.onSearchClear,
      "input": _vm.onSearch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filtering) ? _c('f7-card') : _vm._e(), _vm._v(" "), (_vm.parent) ? _c('f7-card', {
    staticClass: "bg-blue color-white parent"
  }, [_c('f7-card-content', [_c('f7-grid', _vm._l((_vm.parentFields), function(field) {
    return (field.showInChildrenList !== false) ? _c('f7-col', {
      key: field.name,
      attrs: {
        "width": "100",
        "tablet-width": field.description === true ? 100 : 50
      }
    }, [_c('span', {
      staticClass: "key"
    }, [_vm._v(_vm._s(field.label) + ":")]), _vm._v(" " + _vm._s(_vm.getFieldValue(_vm.parent, field)) + "\n                ")]) : _vm._e()
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("before-list"), _vm._v(" "), (_vm.vLayout === 'table') ? _vm._t("default", [_c('v-table', {
    attrs: {
      "items": _vm.visibleItems,
      "columns": _vm.fields,
      "actions": _vm.actions
    },
    on: {
      "onItemClick": _vm.onItemClick1
    }
  })]) : _vm._t("default", [(_vm.visibleItems && _vm.visibleItems.length > 0) ? _c('v-virtual-cards', {
    staticStyle: {
      "margin-bottom": "70px"
    },
    attrs: {
      "render-item-header": _vm.renderItemHeader1,
      "render-item-content": _vm.renderItemContent1,
      "render-item-footer": _vm.renderItemFooter1,
      "virtual-items": _vm.visibleItems,
      "name": _vm.listKey.toLowerCase() + (_vm.vvType ? '-' + _vm.vvType : ''),
      "virtual-height": _vm.virtualHeight || _vm.virtualHeight1
    },
    on: {
      "onItemClick": _vm.onItemClick1
    }
  }) : _vm._e()]), _vm._v(" "), _vm._t("after-list"), _vm._v(" "), (_vm.sorting) ? _c('f7-popover', {
    class: 'popover-sort-' + _vm.listKey.toLowerCase() + (_vm.vvType === 'vlistfield' ? '-vlistfield' : '')
  }, [_c('f7-block-title', [_vm._v(_vm._s(_vm.$root.__('Sorting with:')))]), _vm._v(" "), _c('f7-list', _vm._l((_vm.sortFields), function(field) {
    return _c('f7-list-item', {
      key: field.name,
      attrs: {
        "link": "#",
        "title": field.label
      },
      on: {
        "click": function($event) {
          _vm.onSort(field.name)
        }
      }
    }, [(_vm.column === field.name) ? _c('f7-icon', {
      attrs: {
        "icon": 'icon-' + _vm.direction.toLowerCase()
      }
    }) : _vm._e()], 1)
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.addButton === true) ? _c('f7-fab', {
    attrs: {
      "color": "orange"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('f7-icon', {
    attrs: {
      "icon": "icon-plus"
    }
  })], 1) : _vm._e()], 2) : _c('div', {
    staticClass: "view navbar-fixed"
  }, [_c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('f7-navbar', {
    style: (_vm.searching ? 'box-shadow: none' : ''),
    attrs: {
      "title": _vm.pageTitle + (_vm.showTotal === true && _vm.total ? ' ( ' + _vm.total + ' )' : ''),
      "back-link": "",
      "sliding": ""
    }
  }, [(_vm.sorting) ? _c('f7-nav-right', [_c('f7-link', {
    class: 'popover-sort-' + _vm.listKey.toLowerCase() + '-place-vlistfield',
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showSortPopup
    }
  }, [_c('f7-icon', {
    attrs: {
      "icon": "icon-sort"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.searching) ? _c('f7-searchbar', {
    attrs: {
      "cancel-link": "Cancel",
      "placeholder": _vm.searchTitle,
      "clear-button": true
    },
    on: {
      "click:clear": _vm.onSearchClear,
      "input": _vm.onSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.visibleItems && _vm.visibleItems.length > 0) ? _c('v-virtual-cards', {
    staticStyle: {
      "margin-bottom": "70px"
    },
    attrs: {
      "render-item-header": _vm.renderItemHeader1,
      "render-item-content": _vm.renderItemContent1,
      "render-item-footer": _vm.renderItemFooter1,
      "virtual-items": _vm.visibleItems,
      "name": _vm.listKey.toLowerCase() + '-' + _vm.vvType,
      "virtual-height": _vm.virtualHeight || _vm.virtualHeight1
    },
    on: {
      "onItemClick": _vm.onItemClick1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sorting) ? _c('f7-popover', {
    class: 'popover-sort-' + _vm.listKey.toLowerCase() + '-vlistfield'
  }, [_c('f7-block-title', [_vm._v(_vm._s(_vm.$root.__('Sorting with:')))]), _vm._v(" "), _c('f7-list', _vm._l((_vm.sortFields), function(field) {
    return _c('f7-list-item', {
      key: field.name,
      attrs: {
        "link": "#",
        "title": field.label
      },
      on: {
        "click": function($event) {
          _vm.onSort(field.name)
        }
      }
    }, [(_vm.column === field.name) ? _c('f7-icon', {
      attrs: {
        "icon": 'icon-' + _vm.direction.toLowerCase()
      }
    }) : _vm._e()], 1)
  }))], 1) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4011f3e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VListPage.vue
// module id = 136
// module chunks = 1